import React, { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as API from 'api/baseAPI';
import logo from 'images/logo.png';
import mobileWebBanner from 'images/web-banner-mobile@2x.jpg';
import webBanner from 'images/web-banner-desktop@2x.jpg';
import beianLogo from 'images/beian.png';
import { getMultiLocaleContent } from 'utils/helper';

import CircularProgress from '@mui/material/CircularProgress';

import LocaleSelector from 'components/localeSelector';
import { DialogContext } from 'components/dialogContext';

import 'styles/scss/components/walkInPage.scss';
import { useMatchMedia } from './useMatchMedia';

const jsonToBase64 = (json) => {
  const jsonString = JSON.stringify(json);

  // Convert string to UTF-8 byte array
  const utf8Bytes = new TextEncoder().encode(jsonString);

  // Encode UTF-8 byte array to Base64
  const base64String = btoa(String.fromCharCode.apply(null, utf8Bytes));

  return base64String;
};

export default function WalkInPage(props) {
  const navigate = useNavigate();
  const { eventId, eventTitle } = props;
  const customization = useSelector((state) => state.event.customization);
  const [title, setTitle] = useState('');
  const [titleError, setTitleError] = useState(null);
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(null);
  const [firstName, setFirstName] = useState('');
  const [firstNameError, setFirstNameError] = useState(null);
  const [lastName, setLastName] = useState('');
  const [lastNameError, setLastNameError] = useState(null);
  const [company, setCompany] = useState('');
  const [companyError, setCompanyError] = useState(null);
  const [jobTitle, setJobTitle] = useState('');
  const [jobTitleError, setJobTitleError] = useState(null);
  const [countryRegion, setCountryRegion] = useState('');
  const [countryRegionError, setCountryRegionError] = useState(null);
  const [phone, setPhone] = useState('');
  const [vegetarian, setVegetarian] = useState(false);
  const [tableNumber, setTableNumber] = useState('');
  const [acceptPrivacyPolice, setAcceptPrivacyPolicy] = useState(false);
  const [acceptPrivacyPoliceError, setAcceptPrivacyPolicyError] = useState(null);
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [submittable, setSubmittable] = useState(true);
  const [customStyle, setCustomStyle] = useState({});
  const [customConfig, setCustomConfig] = useState({
    enableLocale: false,
    availableLocales: ['en', 'zh-Hans', 'zh-Hant'],
    metadata: [],
    logoImageUrl: null,
    logoImageUrlMobile: null,
    logoInHeader: false,
    footerImageUrl: null,
    footerText: null,
    footerLink: null,
    hideFooter: false,
    hideFooterLink: false,
    mobileBanner: mobileWebBanner,
    mobileBottomBanner: null,
    label: null,
    title: null,
    submitButtonText: null,
    remarks: [],
    ignoreCase: false,
    autoCapitalize: false,
    errorMessage: null,
    hideInputForm: false,
    tabletBreakpoint: 768,
    desktopBreakpoint: 992,
  });
  const { openDialog, closeDialog } = useContext(DialogContext);
  const { isTablet, isDesktop } = useMatchMedia({
    tabletBreakpoint: customConfig.tabletBreakpoint,
    desktopBreakpoint: customConfig.desktopBreakpoint,
  });
  const [triggeredValidate, setTriggeredValidate] = useState(false);
  const [isVirtual, setIsVirtual] = useState(false);

  const validate = useCallback(() => {
    setTriggeredValidate(true);
    let valid = true;
    if (valid) {
      /*
      if (title.trim() === '') {
        valid = false;
        setTitleError('Please select your title');
      } else {
        setTitleError(null);
      }
      if (email.trim() === '') {
        valid = false;
        setEmailError('Please enter your email address');
      } else {
        setEmailError(null);
      }
      */
      if (firstName.trim() === '') {
        valid = false;
        setFirstNameError('Please enter your first name');
      } else {
        setFirstNameError(null);
      }
      /*
      if (lastName.trim() === '') {
        valid = false;
        setLastNameError('Please enter your last name');
      } else {
        setLastNameError(null);
      }
      if (jobTitle.trim() === '') {
        valid = false;
        setJobTitleError('Please enter your job title');
      } else {
        setJobTitleError(null);
      }
      if (company.trim() === '') {
        valid = false;
        setCompanyError('Please enter your company');
      } else {
        setCompanyError(null);
      }
      if (countryRegion.trim() === '') {
        valid = false;
        setCountryRegionError('Please select your country or region');
      } else {
        setCountryRegionError(null);
      }
      if (!acceptPrivacyPolice) {
        valid = false;
        setAcceptPrivacyPolicyError('Please accept the Privacy Policy statement');
      } else {
        setAcceptPrivacyPolicyError(null);
      }
      */
    }

    setSubmittable(valid);
    return valid;
  }, [acceptPrivacyPolice, company, countryRegion, email, firstName, jobTitle, lastName, title]);

  const passcodeSubmitHandler = (e) => {
    if (e) {
      e.preventDefault();
    }
    if (loading) {
      return;
    }
    setLoading(true);
    const form = document.getElementById('walk-in-form');
    form.checkValidity();
    if (!form.reportValidity()) {
      setLoading(false);
      return;
    }
    let valid = validate();
    if (!valid) {
      setLoading(false);
      setTimeout(() => {
        document
          .getElementsByClassName('input-row error')[0]
          .scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      const data = {
        email: email.trim(),
      };
      const metadata = {
        title: title,
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        name: `${title} ${firstName.trim()} ${lastName.trim()}`,
        jobTitle: jobTitle.trim(),
        company: company.trim(),
        phone: phone,
        countryRegion: countryRegion,
      };
      if (!isVirtual && false) {
        metadata.vegetarianMenu = vegetarian;
      }
      data.metadata = metadata;
      if (tableNumber) {
        data.remarks = {
          table: tableNumber,
        };
      }

      API.walkIn(eventId, data)
        .then(() => {
          setLoading(false);
          /*
          openDialog('Submit Success', () => {
            closeDialog();
            // navigate(`/event/${eventId}`);
            window.location.reload();
          });
          */
          window.location.href = `/walk-in/${eventId}?result=success&data=${jsonToBase64(data)}`;
        })
        .catch((err) => {
          setLoading(false);
          /*
          if (err && err.response && err.response.status === 409) {
            openDialog('Submit Failed\nThis email address is already registered', closeDialog);
          } else {
            openDialog('Submit Failed', closeDialog);
          }
          */
          window.location.href = `/walk-in/${eventId}?result=failed`;
        });
    }
  };

  useEffect(() => {
    if (customization.passcode) {
      if (customization.passcode.style) {
        let customStyle = {};
        for (const [key, value] of Object.entries(customization.passcode.style)) {
          customStyle[key] = value;
        }
        setCustomStyle(customStyle);
      }
      if (customization.passcode.config) {
        setCustomConfig((customConfig) => ({
          ...customConfig,
          ...customization.passcode.config,
        }));
      }
    }
    if (customization.virtual === true) {
      setIsVirtual(true);
    }
  }, [customization]);

  useEffect(() => {
    if (triggeredValidate) {
      validate();
    }
  }, [triggeredValidate, validate]);

  const emailChangeHandler = (e) => {
    setEmail(e.target.value);
  };

  const countryRegionChangeHandler = (e) => {
    setCountryRegion(e.target.value);
  };
  const titleChangeHandler = (e) => {
    setTitle(e.target.value);
  };

  const firstNameChangeHandler = (e) => {
    setFirstName(e.target.value);
  };

  const lastNameChangeHandler = (e) => {
    setLastName(e.target.value);
  };

  const jobTitleChangeHandler = (e) => {
    setJobTitle(e.target.value);
  };

  const companyChangeHandler = (e) => {
    setCompany(e.target.value);
  };

  const phoneChangeHandler = (e) => {
    setPhone(e.target.value);
  };

  const vegetarianMenuChangeHandler = (e) => {
    setVegetarian(e.target.checked);
  };

  const acceptPrivacyPoliceChangeHandler = (e) => {
    setAcceptPrivacyPolicy(e.target.checked);
  };

  const tableNumberChangeHandler = (e) => {
    setTableNumber(e.target.value);
  };

  window.submitForm = passcodeSubmitHandler;

  return (
    <div
      className={`walk-in-page${isTablet ? ' tablet' : ''}${isDesktop ? ' desktop' : ''}`}
      style={customStyle}
    >
      <div className="background-wrapper">
        <div className="content">
          <div className="content-container">
            {
              <form id="walk-in-form" onSubmit={passcodeSubmitHandler}>
                <div className={`input-container`}>
                  <div className={`input-row${titleError ? ' error' : ''}`}>
                    <label className="input-label" htmlFor="country-region">
                      Title:
                    </label>
                    <div className="select-wrapper">
                      <select value={title} name="title" id="title" onChange={titleChangeHandler}>
                        <option value="">Please select</option>
                        <option value="Prof">Prof</option>
                        <option value="Dr">Dr</option>
                        <option value="Mr">Mr</option>
                        <option value="Mrs">Mrs</option>
                        <option value="Ms">Ms</option>
                        <option value="Miss">Miss</option>
                      </select>
                    </div>
                    <div className="error">{titleError}</div>
                  </div>
                  <div className={`input-row${firstNameError ? ' error' : ''}`}>
                    <label className="input-label" htmlFor="firstName">
                      First Name*:
                    </label>
                    <input
                      value={firstName}
                      type="text"
                      name="firstName"
                      id="firstName"
                      maxLength={50}
                      onChange={firstNameChangeHandler}
                    />
                    <div className="error">{firstNameError}</div>
                  </div>
                  <div className={`input-row${lastNameError ? ' error' : ''}`}>
                    <label className="input-label" htmlFor="lastName">
                      Last Name:
                    </label>
                    <input
                      value={lastName}
                      type="text"
                      name="lastName"
                      id="lastName"
                      maxLength={50}
                      onChange={lastNameChangeHandler}
                    />
                    <div className="error">{lastNameError}</div>
                  </div>
                  <div className={`input-row${jobTitleError ? ' error' : ''}`}>
                    <label className="input-label" htmlFor="jobTitle">
                      Job Title:
                    </label>
                    <input
                      value={jobTitle}
                      type="text"
                      name="jobTitle"
                      id="jobTitle"
                      maxLength={300}
                      onChange={jobTitleChangeHandler}
                    />
                    <div className="error">{jobTitleError}</div>
                  </div>
                  <div className={`input-row${companyError ? ' error' : ''}`}>
                    <label className="input-label" htmlFor="company">
                      Company:
                    </label>
                    <input
                      value={company}
                      type="text"
                      name="company"
                      id="company"
                      maxLength={300}
                      onChange={companyChangeHandler}
                    />
                    <div className="error">{companyError}</div>
                  </div>
                  <div className={`input-row${emailError ? ' error' : ''}`}>
                    <label className="input-label" htmlFor="email">
                      Email Address:
                    </label>
                    <input
                      value={email}
                      type="email"
                      name="email"
                      id="email"
                      pattern="^[a-zA-Z0-9.!#$%&'*+\/=?^_`\{\|\}~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?)+$"
                      onChange={emailChangeHandler}
                    />
                    <div className="error">{emailError}</div>
                  </div>
                  <div className={`input-row${countryRegionError ? ' error' : ''}`}>
                    <label className="input-label" htmlFor="country-region">
                      Country/Region:
                    </label>
                    <div className="select-wrapper">
                      <select
                        value={countryRegion}
                        name="country-region"
                        id="country-region"
                        onChange={countryRegionChangeHandler}
                      >
                        <option value="">Please select</option>
                        <option value="Hong Kong">Hong Kong</option>
                        <option value="Afghanistan">Afghanistan</option>
                        <option value="Albania">Albania</option>
                        <option value="Algeria">Algeria</option>
                        <option value="Argentina">Argentina</option>
                        <option value="Armenia">Armenia</option>
                        <option value="Australia">Australia</option>
                        <option value="Austria">Austria</option>
                        <option value="Azerbaijan">Azerbaijan</option>
                        <option value="Bahrain">Bahrain</option>
                        <option value="Bangladesh">Bangladesh</option>
                        <option value="Belgium">Belgium</option>
                        <option value="Belize">Belize</option>
                        <option value="Benin">Benin</option>
                        <option value="Bhutan">Bhutan</option>
                        <option value="Bolivia">Bolivia</option>
                        <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                        <option value="Botswana">Botswana</option>
                        <option value="Brazil">Brazil</option>
                        <option value="Brunei">Brunei</option>
                        <option value="Bulgaria">Bulgaria</option>
                        <option value="Burkina Faso">Burkina Faso</option>
                        <option value="Burundi">Burundi</option>
                        <option value="Cambodia">Cambodia</option>
                        <option value="Cameroon">Cameroon</option>
                        <option value="Canada">Canada</option>
                        <option value="Canary Islands">Canary Islands</option>
                        <option value="Cape Verde">Cape Verde</option>
                        <option value="Central African Republic">Central African Republic</option>
                        <option value="Ceuta">Ceuta</option>
                        <option value="Chad">Chad</option>
                        <option value="Chile">Chile</option>
                        <option value="Mainland China">Mainland China</option>
                        <option value="Colombia">Colombia</option>
                        <option value="Comoros">Comoros</option>
                        <option value="Congo">Congo</option>
                        <option value="Costa Rica">Costa Rica</option>
                        <option value="Côte d'Ivoire">Côte d'Ivoire</option>
                        <option value="Croatia">Croatia</option>
                        <option value="Cyprus">Cyprus</option>
                        <option value="Czech Republic">Czech Republic</option>
                        <option value="Denmark">Denmark</option>
                        <option value="Djibouti">Djibouti</option>
                        <option value="East Timor (Timor Timur)">East Timor (Timor Timur)</option>
                        <option value="Ecuador">Ecuador</option>
                        <option value="Egypt">Egypt</option>
                        <option value="El Salvador">El Salvador</option>
                        <option value="Equatorial Guinea">Equatorial Guinea</option>
                        <option value="Eritrea">Eritrea</option>
                        <option value="Ethiopia">Ethiopia</option>
                        <option value="Falkland Islands">Falkland Islands</option>
                        <option value="Finland">Finland</option>
                        <option value="France">France</option>
                        <option value="French Guiana">French Guiana</option>
                        <option value="Gabon">Gabon</option>
                        <option value="Gaza">Gaza</option>
                        <option value="Gambia">Gambia</option>
                        <option value="Georgia">Georgia</option>
                        <option value="Germany">Germany</option>
                        <option value="Ghana">Ghana</option>
                        <option value="Greece">Greece</option>
                        <option value="Guatemala">Guatemala</option>
                        <option value="Guinea">Guinea</option>
                        <option value="Guinea-Bissau">Guinea-Bissau</option>
                        <option value="Guyana">Guyana</option>
                        <option value="Honduras">Honduras</option>
                        <option value="Hungary">Hungary</option>
                        <option value="Iceland">Iceland</option>
                        <option value="India">India</option>
                        <option value="Indonesia">Indonesia</option>
                        <option value="Iran">Iran</option>
                        <option value="Iraq">Iraq</option>
                        <option value="Ireland">Ireland</option>
                        <option value="Israel">Israel</option>
                        <option value="Italy">Italy</option>
                        <option value="Japan">Japan</option>
                        <option value="Jordan">Jordan</option>
                        <option value="Kazakhstan">Kazakhstan</option>
                        <option value="Kenya">Kenya</option>
                        <option value="Korea, North">Korea, North</option>
                        <option value="Korea, South">Korea, South</option>
                        <option value="Kosovo">Kosovo</option>
                        <option value="Kuwait">Kuwait</option>
                        <option value="Kyrgyzstan">Kyrgyzstan</option>
                        <option value="Laos">Laos</option>
                        <option value="Lebanon">Lebanon</option>
                        <option value="Lesotho">Lesotho</option>
                        <option value="Liberia">Liberia</option>
                        <option value="Libya">Libya</option>
                        <option value="Liechtenstein">Liechtenstein</option>
                        <option value="Luxembourg">Luxembourg</option>
                        <option value="Macau">Macau</option>
                        <option value="Macedonia">Macedonia</option>
                        <option value="Madagascar">Madagascar</option>
                        <option value="Madeira Islands">Madeira Islands</option>
                        <option value="Malawi">Malawi</option>
                        <option value="Malaysia">Malaysia</option>
                        <option value="Maldives">Maldives</option>
                        <option value="Mali">Mali</option>
                        <option value="Mauritania">Mauritania</option>
                        <option value="Mauritius">Mauritius</option>
                        <option value="Mayotte">Mayotte</option>
                        <option value="Melilla">Melilla</option>
                        <option value="Mexico">Mexico</option>
                        <option value="Mongolia">Mongolia</option>
                        <option value="Montenegro">Montenegro</option>
                        <option value="Morocco">Morocco</option>
                        <option value="Mozambique">Mozambique</option>
                        <option value="Myanmar (Burma)">Myanmar (Burma)</option>
                        <option value="Namibia">Namibia</option>
                        <option value="Nepal">Nepal</option>
                        <option value="Netherlands">Netherlands</option>
                        <option value="New Zealand">New Zealand</option>
                        <option value="Nicaragua">Nicaragua</option>
                        <option value="Niger">Niger</option>
                        <option value="Nigeria">Nigeria</option>
                        <option value="Norway">Norway</option>
                        <option value="Oman">Oman</option>
                        <option value="Pakistan">Pakistan</option>
                        <option value="Panama">Panama</option>
                        <option value="Paraguay">Paraguay</option>
                        <option value="Patagonia">Patagonia</option>
                        <option value="Peru">Peru</option>
                        <option value="Philippines">Philippines</option>
                        <option value="Poland">Poland</option>
                        <option value="Portugal">Portugal</option>
                        <option value="Qatar">Qatar</option>
                        <option value="Réunion">Réunion</option>
                        <option value="Romania">Romania</option>
                        <option value="Russia">Russia</option>
                        <option value="Rwanda">Rwanda</option>
                        <option value="Saint Helena, Ascension and Tristan da Cunha (UK)">
                          Saint Helena, Ascension and Tristan da Cunha (UK)
                        </option>
                        <option value="São Tomé and Príncipe">São Tomé and Príncipe</option>
                        <option value="Saudi Arabia">Saudi Arabia</option>
                        <option value="Senegal">Senegal</option>
                        <option value="Serbia">Serbia</option>
                        <option value="Seychelles">Seychelles</option>
                        <option value="Sierra Leone">Sierra Leone</option>
                        <option value="Singapore">Singapore</option>
                        <option value="Slovakia">Slovakia</option>
                        <option value="Slovenia">Slovenia</option>
                        <option value="Somalia">Somalia</option>
                        <option value="South Middle East &amp; Africa">
                          South Middle East &amp; Africa
                        </option>
                        <option value="Spain">Spain</option>
                        <option value="Sri Lanka">Sri Lanka</option>
                        <option value="Sudan">Sudan</option>
                        <option value="Suriname">Suriname</option>
                        <option value="Swaziland">Swaziland</option>
                        <option value="Sweden">Sweden</option>
                        <option value="Switzerland">Switzerland</option>
                        <option value="Syria">Syria</option>
                        <option value="Taiwan">Taiwan</option>
                        <option value="Tajikistan">Tajikistan</option>
                        <option value="Tanzania">Tanzania</option>
                        <option value="Thailand">Thailand</option>
                        <option value="Togo">Togo</option>
                        <option value="Tunisia">Tunisia</option>
                        <option value="Turkey">Turkey</option>
                        <option value="Turkmenistan">Turkmenistan</option>
                        <option value="Uganda">Uganda</option>
                        <option value="Ukraine">Ukraine</option>
                        <option value="United Arab Emirates">United Arab Emirates</option>
                        <option value="United Kingdom">United Kingdom</option>
                        <option value="United States">United States</option>
                        <option value="Uruguay">Uruguay</option>
                        <option value="Uzbekistan">Uzbekistan</option>
                        <option value="Venezuela">Venezuela</option>
                        <option value="Vietnam">Vietnam</option>
                        <option value="Western Sahara">Western Sahara</option>
                        <option value="Yemen">Yemen</option>
                        <option value="Zambia">Zambia</option>
                        <option value="Zimbabwe">Zimbabwe</option>
                      </select>
                    </div>
                    <div className="error">{countryRegionError}</div>
                  </div>
                  <div className="input-row">
                    <label className="input-label" htmlFor="phone">
                      Phone:
                    </label>
                    <input
                      value={phone}
                      type="text"
                      name="phone"
                      id="phone"
                      onChange={phoneChangeHandler}
                    />
                  </div>
                  {false && (
                    <Fragment>
                      <div className="input-row">
                        <label className="input-label">Dietary Preference:</label>
                        <div className="checkbox-container">
                          <input
                            type="checkbox"
                            name="vegetarian-menu"
                            id="vegetarian-menu"
                            checked={vegetarian}
                            onChange={vegetarianMenuChangeHandler}
                          />
                          <label className="input-label" htmlFor="vegetarian-menu">
                            Vegetarian menu is required
                          </label>
                        </div>
                      </div>
                    </Fragment>
                  )}
                  <div className="input-row">
                    <label className="input-label" htmlFor="lastName">
                      Table Number:
                    </label>
                    <input
                      value={tableNumber}
                      type="text"
                      name="tableNumber"
                      id="tableNumber"
                      onChange={tableNumberChangeHandler}
                    />
                    <div className="error"></div>
                  </div>
                </div>
              </form>
            }
          </div>
        </div>
      </div>
    </div>
  );
}
